import { connect } from 'react-redux';

import { IApplicationState } from '@store';
import routes from '@configs/routes.json';

import Help, { IHelpStateProps } from '../components/help/Help';
interface IStateToProps
  extends Pick<IApplicationState, 'builds' | 'customMessages'> {}

const mapStateToProps = ({
  builds,
  customMessages,
}: IStateToProps): IHelpStateProps => ({
  builds: builds.builds.map((build) => ({
    ...build,
    downloadLink: routes.api.assets.build
      .replace(':build', build.build)
      .replace(':hashFile', 'false'),
    md5Link: routes.api.assets.build
      .replace(':build', build.build)
      .replace(':hashFile', 'true'),
  })),
  content: customMessages.help,
});

export default connect(mapStateToProps)(Help);
